import React from 'react'

export const GenericErrorImage = () => (
  <svg
    width="100%"
    height="auto"
    viewBox="0 0 512 279"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M255.775 278.283C397.036 278.283 511.55 271.175 511.55 262.407C511.55 253.639 397.036 246.531 255.775 246.531C114.514 246.531 0 253.639 0 262.407C0 271.175 114.514 278.283 255.775 278.283Z"
      fill="#F2E5FF"
    />
    <path
      d="M308.632 101.091C298.005 120.026 366.632 262.863 366.632 262.863H305.486L258.375 188.568"
      fill="#3D0083"
    />
    <path
      d="M322.237 136.36C322.237 136.36 275.989 235.466 252.31 234.913C228.63 234.361 202.754 182.608 202.754 182.608L267.175 114.332L322.237 136.354V136.36Z"
      fill="#3D0083"
    />
    <path
      d="M267.988 94.8967C265.082 95.3517 262.183 95.6832 259.278 95.8912C262.17 95.6832 265.076 95.3517 267.988 94.8967Z"
      fill="#3D0083"
    />
    <path
      d="M257.984 188.516L284.563 262.811H151.813C140.25 262.811 129.674 258.632 121.491 251.618C101.685 262.876 74.4114 261.648 74.4114 261.648L69.4648 248.836C69.4648 248.836 99.3128 249.655 108.12 232.749C56.9003 88.3901 171.755 47.0177 171.755 47.0177C171.755 47.0177 256.353 104.614 299.383 80.4797C299.597 80.3627 302.035 83.0342 302.236 82.9172V82.8846L273.727 4.66365C273.584 4.27365 273.415 3.91616 273.207 3.57166L311.453 3.58465C328.873 3.58465 344.857 13.3866 352.65 28.9736C362.764 49.2081 372.891 101.553 388.998 106.941C404.169 112.018 408.771 99.9082 412.977 77.1452C414.283 70.0797 417.969 64.0151 421.96 61.9416C428.323 58.6396 447.836 60.1996 442.883 67.6291C440.335 71.4446 435.818 74.8507 435.083 85.3092C433.322 110.419 417.754 149.269 379.95 146.702C339.429 143.946 338.383 95.6182 306.065 102.931"
      fill="#7130C9"
    />
    <path
      d="M303.01 82.8457C292.272 86.7652 281.268 88.3317 270.484 88.1237C254.306 87.8247 238.608 83.1447 225.036 74.8377C222.768 73.4532 220.564 71.9647 218.432 70.3917C216.294 68.8057 214.22 67.1287 212.225 65.3607C208.962 62.4682 205.907 59.3157 203.073 55.9357C203.3 56.2152 203.528 56.4947 203.755 56.7677C203.521 56.4947 203.3 56.2152 203.073 55.9357C198.958 51.0347 195.312 45.6592 192.257 39.8157C187.466 40.9142 172.165 47.0697 172.165 47.0697C199.66 128.801 303.01 82.8457 303.01 82.8457Z"
      fill="#3D0083"
    />
    <path
      d="M224.659 74.9547C238.237 83.2552 253.922 87.9417 270.107 88.2407C280.89 88.4422 291.901 86.8822 302.646 82.9627L274.137 4.53367C273.994 4.14367 273.825 3.78616 273.617 3.44166C271.966 0.59466 268.482 -0.744336 265.284 0.419164L186.283 29.2077L191.886 39.9262C201.545 58.3992 215.903 68.9097 218.061 70.5087C220.2 72.0947 222.403 73.5767 224.665 74.9547L224.652 74.9417L224.659 74.9547Z"
      fill="#9865FC"
    />
    <path
      d="M74.8144 261.648H26.7534C25.5964 261.648 25.0504 260.224 25.9214 259.457C34.2739 252.093 61.9444 229.759 69.8809 248.823L74.8274 261.635L74.8144 261.648Z"
      fill="#3D0083"
    />
    <path
      d="M159.925 143.211C179.146 142.451 198.529 142.561 217.457 146.539C234.337 150.114 242.872 156.757 251.848 171.382C254.325 175.503 256.515 179.78 258.296 184.22C254.149 175.698 248.787 167.58 241.929 161.054C235.085 154.261 226.102 151.434 216.781 150.043C198.041 147.287 178.723 148.457 159.919 150.355C154.764 150.576 154.68 143.101 159.919 143.205L159.925 143.211Z"
      fill="#3D0083"
    />
    <path
      d="M216.066 262.863L199.159 215.277C199.159 241.563 178.138 262.863 152.21 262.863"
      fill="#3D0083"
    />
    <path
      d="M250.054 109.502C250.054 109.502 273.298 139.357 281.989 137.03C291.901 133.728 302.412 98.9202 302.412 98.9202C302.412 98.9202 314.242 93.1352 336.998 112.96C328.925 143.796 312.324 186.28 282.223 189.218C246.232 192.728 188.987 148.106 182.383 131.96L250.048 109.509L250.054 109.502Z"
      fill="#7130C9"
    />
    <path
      d="M336.264 115.801C329.562 139.695 318.987 171.168 297.342 185.37C275.04 200.067 240.291 182.621 220.2 170.199C212.51 165.376 205.12 160.066 198.126 154.216C191.983 148.957 185.834 143.419 181.252 136.62C180.569 135.567 179.919 134.462 179.367 133.162C178.665 131.511 179.432 129.6 181.083 128.898C182.734 128.196 184.645 128.963 185.347 130.614C185.659 131.446 186.127 132.317 186.666 133.208C190.722 139.552 196.28 144.804 201.863 149.88C218.445 164.31 237.36 176.81 258.231 184.031C270.406 188.094 284.53 190.232 295.996 183.154C317.472 169.985 328.964 138.934 336.257 115.794L336.264 115.801Z"
      fill="#3D0083"
    />
    <path
      d="M263.061 115.17C263.958 122.886 268.462 130.666 276.061 133.37C277.894 133.962 279.824 134.599 281.761 134.469C285.772 134.059 288.469 130.023 290.127 126.552C291.03 124.628 291.765 122.6 292.298 120.513C292.025 122.652 291.537 124.771 290.855 126.844C289.106 132.376 285.122 138.005 278.537 136.861C275.079 136.445 271.758 135.275 268.839 133.312C262.976 129.314 259.304 122.684 257.906 115.827C257.328 112.154 262.723 111.465 263.067 115.177L263.061 115.17Z"
      fill="#3D0083"
    />
    <path
      d="M220.882 255.362C220.928 242.694 239.134 242.856 239.765 255.362H236.944C237.217 241.342 257.321 241.524 258.023 255.362H253.168C253.096 252.47 254.364 249.571 256.463 247.608C262.898 241.355 274.559 246.256 273.077 255.362C273.019 255.616 272.655 255.616 272.609 255.362C271.608 249.33 263.912 246.275 259.791 250.936C258.647 252.184 258.056 253.828 258.023 255.492C257.841 258.671 253.181 258.547 253.168 255.369C253.064 246.282 240.155 246.6 239.765 255.486C239.661 257.332 236.898 257.228 236.944 255.369C237.275 248.713 228.877 245.086 224.048 249.675C222.488 251.085 221.454 253.165 221.35 255.369C221.35 255.655 220.882 255.655 220.882 255.369V255.362Z"
      fill="#3D0083"
    />
    <path
      d="M296.757 108.638C298.291 99.7522 311.05 102.027 310.01 110.88L308.028 110.542C309.887 100.734 323.972 103.249 322.822 113.045L319.416 112.466C319.708 110.432 320.943 108.54 322.646 107.416C327.905 103.789 335.503 108.612 333.384 114.832C333.313 115.001 333.059 114.962 333.053 114.774C333.066 110.419 328.028 107.364 324.583 110.146C323.628 110.887 323.023 111.972 322.802 113.129C322.295 115.339 319.039 114.696 319.409 112.466C320.417 106.077 311.317 104.77 309.991 110.958C309.698 112.239 307.768 111.842 308.021 110.542C309.042 105.914 303.582 102.372 299.649 105.017C298.388 105.823 297.413 107.156 297.082 108.69C297.049 108.891 296.718 108.833 296.75 108.631L296.757 108.638Z"
      fill="#3D0083"
    />
    <path
      d="M313.975 47.0502C316.731 47.5377 319.182 48.4997 321.112 49.7282C321.925 48.5257 322.399 47.0762 322.399 45.5162C322.399 41.3887 319.091 38.0347 315.002 38.0347C310.914 38.0347 307.605 41.3822 307.605 45.5162C307.605 45.9777 307.651 46.4197 307.729 46.8552C309.64 46.6082 311.765 46.6602 313.969 47.0502H313.975Z"
      fill="white"
    />
    <path
      d="M457.456 191.248H441.076C434.795 191.248 429.69 186.142 429.69 179.862V130.369C429.69 124.089 434.795 118.983 441.076 118.983H457.456C463.736 118.983 468.842 124.089 468.842 130.369V179.862C468.842 186.142 463.736 191.248 457.456 191.248ZM441.076 124.173C437.661 124.173 434.893 126.948 434.893 130.356V179.849C434.893 183.263 437.668 186.031 441.076 186.031H457.456C460.87 186.031 463.638 183.257 463.638 179.849V130.356C463.638 126.955 460.864 124.173 457.456 124.173H441.076Z"
      fill="#342700"
    />
    <path
      d="M427.229 265.399C430.832 265.399 433.757 262.474 433.757 258.87C433.757 255.267 430.832 252.342 427.229 252.342C423.625 252.342 420.7 255.267 420.7 258.87C420.7 262.474 423.625 265.399 427.229 265.399Z"
      fill="#342700"
    />
    <path
      d="M427.229 260.744C428.267 260.744 429.102 259.902 429.102 258.87C429.102 257.839 428.26 256.997 427.229 256.997C426.197 256.997 425.355 257.839 425.355 258.87C425.355 259.902 426.197 260.744 427.229 260.744Z"
      fill="#FFC103"
    />
    <path
      d="M470.474 265.399C474.078 265.399 477.002 262.474 477.002 258.87C477.002 255.267 474.078 252.342 470.474 252.342C466.87 252.342 463.945 255.267 463.945 258.87C463.945 262.474 466.87 265.399 470.474 265.399Z"
      fill="#342700"
    />
    <path
      d="M470.474 260.744C471.512 260.744 472.347 259.902 472.347 258.87C472.347 257.839 471.505 256.997 470.474 256.997C469.442 256.997 468.6 257.839 468.6 258.87C468.6 259.902 469.442 260.744 470.474 260.744Z"
      fill="#FFC103"
    />
    <path
      d="M480.789 238.214L480.743 173.823C480.743 166.041 474.424 159.734 466.635 159.741L418.97 159.774C411.188 159.774 404.882 166.093 404.888 173.882L404.934 238.273C404.934 246.055 411.254 252.361 419.042 252.355L466.707 252.322C474.489 252.322 480.796 246.003 480.789 238.214Z"
      fill="#FFE183"
    />
    <path
      d="M492.834 238.214L492.789 173.823C492.789 166.041 486.469 159.734 478.687 159.741L431.022 159.774C423.24 159.774 416.933 166.093 416.94 173.882L416.986 238.273C416.986 246.055 423.305 252.361 431.094 252.355L478.759 252.322C486.541 252.322 492.847 246.003 492.841 238.214H492.834Z"
      fill="#FFC103"
    />
    <path
      d="M484.595 172.478L481.991 242.908L479.386 172.478C479.333 168.946 484.648 168.92 484.589 172.478H484.595Z"
      fill="#CC8800"
    />
    <path
      d="M430.356 172.478L427.751 242.908L425.146 172.478C425.094 168.946 430.402 168.92 430.35 172.478H430.356Z"
      fill="#CC8800"
    />
    <path
      d="M443.916 172.478L441.311 242.908L438.706 172.478C438.654 168.946 443.961 168.92 443.909 172.478H443.916Z"
      fill="#CC8800"
    />
    <path
      d="M457.482 172.478L454.877 242.908L452.272 172.478C452.22 168.946 457.528 168.92 457.476 172.478H457.482Z"
      fill="#CC8800"
    />
    <path
      d="M471.035 172.478L468.43 242.908L465.826 172.478C465.773 168.946 471.081 168.92 471.029 172.478H471.035Z"
      fill="#CC8800"
    />
  </svg>
)
